import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { useSettingsStore } from '@/store/settingsStore';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { validatePhoneNumber } from '@/utils/validation';

export function WhatsAppSettings() {
  const { settings, updateSettings } = useSettingsStore();
  const [number, setNumber] = useState(settings.whatsappNumber);
  const [message, setMessage] = useState(settings.whatsappMessage || '');
  const [showMessage, setShowMessage] = useState(!!settings.whatsappMessage);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validatePhoneNumber(number)) {
      setError('رقم الهاتف غير صحيح');
      return;
    }

    updateSettings({
      whatsappNumber: number,
      whatsappMessage: showMessage ? message : ''
    });

    setError('');
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <MessageCircle className="h-5 w-5 text-[#25D366]" />
        <h3 className="text-lg font-semibold">إعدادات واتساب</h3>
      </div>

      <div className="space-y-2">
        <Label htmlFor="whatsappNumber">رقم الواتساب</Label>
        <Input
          id="whatsappNumber"
          value={number}
          onChange={(e) => {
            setNumber(e.target.value);
            setError('');
          }}
          placeholder="05xxxxxxxx"
          dir="ltr"
          className="text-left"
        />
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="enableMessage" className="cursor-pointer">تفعيل الرسالة الافتراضية</Label>
          <Switch
            id="enableMessage"
            checked={showMessage}
            onCheckedChange={setShowMessage}
          />
        </div>

        {showMessage && (
          <div className="mt-4">
            <Label htmlFor="whatsappMessage">الرسالة الافتراضية</Label>
            <Input
              id="whatsappMessage"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="أدخل الرسالة الافتراضية"
            />
          </div>
        )}
      </div>

      <Button type="submit" className="bg-[#25D366] hover:bg-[#128C7E]">
        <MessageCircle className="h-4 w-4 ml-2" />
        حفظ الإعدادات
      </Button>
    </form>
  );
}